export default __webpack_public_path__ + "locales/sr-Latn-RS/CreateEditRoomDialog.json?hash=79d9f2b48421f671f8972229623eddc3";